import { ImageDisplayStyle } from 'shared/domain/report/types/model/common';

export const ISSUE_REPORT_DISPLAY_STYLES: ImageDisplayStyle[] = [
  ImageDisplayStyle.miniatures,
  ImageDisplayStyle.list,
  ImageDisplayStyle.fullPage,
];

export const INSPECTION_REPORT_DISPLAY_STYLES: ImageDisplayStyle[] = [
  ImageDisplayStyle.list,
  ImageDisplayStyle.miniatures,
];
